module.exports = __webpack_public_path__ + "img/loading_blogo0.a74867ad.gif";